<template>
  <div class="d-flex flex-column">
    <img alt="" style="width: 150px;height: auto;" class="mrx-auto mlx-auto" :src="require('@/assets/image/cluna.jpg')">
    <span class="mlx-auto mrx-auto mt-5 mb-5" style="color: #9a9696; font-size: 15px !important;">
          {{ oracle.translate('در حال حاضر موردی ثبت نشده است') }}
        </span>
  </div>
</template>

<script>
import oracle from "../oracle";

export default {
  name: "placeholder",
  computed: {
    oracle() {
      return oracle
    }
  }
}
</script>

<style scoped>

</style>